/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  FwenStaker,
  FwenStakerInterface,
} from "../../../../contracts/fwen/FwenStaker.sol/FwenStaker";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ArrayLengthMismatch",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidRegisterTime",
    type: "error",
  },
  {
    inputs: [],
    name: "NonAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwner",
    type: "error",
  },
  {
    inputs: [],
    name: "NonOwnerOrAdmin",
    type: "error",
  },
  {
    inputs: [],
    name: "RegisterEnded",
    type: "error",
  },
  {
    inputs: [],
    name: "RegisterNotStart",
    type: "error",
  },
  {
    inputs: [],
    name: "RegisterStarted",
    type: "error",
  },
  {
    inputs: [],
    name: "StakingUncancelable",
    type: "error",
  },
  {
    inputs: [],
    name: "TokenAlreadyStaked",
    type: "error",
  },
  {
    inputs: [],
    name: "WrongOrderId",
    type: "error",
  },
  {
    inputs: [],
    name: "WrongTokenNumber",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "enum FwenStaker.StakingStatus",
        name: "status",
        type: "uint8",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "StakingStatusChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "orderIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "tokenNums",
        type: "uint256[]",
      },
    ],
    name: "batchUnstakeByAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "programId",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "registerStartTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "registerEndTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "rewardAction",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "tokenNumber",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "rewardContracts",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "cancelable",
        type: "bool",
      },
    ],
    name: "configStakingProgram",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "stakingProgramId",
        type: "uint128",
      },
    ],
    name: "ifStakingEnded",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "stakingProgramId",
        type: "uint128",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "stakeTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stakedTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    name: "stakingPrograms",
    outputs: [
      {
        internalType: "uint256",
        name: "registerStartTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "registerEndTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "enum FwenStaker.RewardAction",
        name: "rewardAction",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "tokenNumber",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "counter",
        type: "uint128",
      },
      {
        internalType: "bool",
        name: "cancelable",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stakingStartTimes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenContractAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "orderId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "unstakeTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "updateAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type FwenStakerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: FwenStakerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class FwenStaker__factory extends ContractFactory {
  constructor(...args: FwenStakerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    addr: PromiseOrValue<string>,
    _admin: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<FwenStaker> {
    return super.deploy(addr, _admin, overrides || {}) as Promise<FwenStaker>;
  }
  override getDeployTransaction(
    addr: PromiseOrValue<string>,
    _admin: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(addr, _admin, overrides || {});
  }
  override attach(address: string): FwenStaker {
    return super.attach(address) as FwenStaker;
  }
  override connect(signer: Signer): FwenStaker__factory {
    return super.connect(signer) as FwenStaker__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FwenStakerInterface {
    return new utils.Interface(_abi) as FwenStakerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FwenStaker {
    return new Contract(address, _abi, signerOrProvider) as FwenStaker;
  }
}
